module.exports = __webpack_public_path__ + "static/img/14.c96b484.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/zh/14.png
// module id = GTtW
// module chunks = 0